import isLiveHelpRequestActive from '@/client/services/liveHelp/isLiveHelpRequestActive'

import type { PostDetails } from '@/components/Community/Post/types'
import type { LiveHelpRequestWithNullableSessionDetails } from '@/components/Worlds/types'

import AuthorAwaitingLiveHelpBanner from './AuthorAwaitingLiveHelpBanner'
import AuthorJoinLiveHelpBanner from './AuthorJoinLiveHelpBanner'
import AuthorReceivedLiveHelpBanner from './AuthorReceivedLiveHelpBanner'
import AuthorRequestLiveHelpBanner from './AuthorRequestLiveHelpBanner'
import { isLiveHelpRequestWithSessionDetails } from './helpers'

export default function AuthorLiveHelpBanner({
  post,
  liveHelpRequest,
  postIsFullView,
}: {
  post: PostDetails
  liveHelpRequest: LiveHelpRequestWithNullableSessionDetails | null
  postIsFullView: boolean
}): JSX.Element {
  if (liveHelpRequest == null || !isLiveHelpRequestActive(liveHelpRequest)) {
    return <AuthorRequestLiveHelpBanner post={post} postIsFullView={postIsFullView} />
  }

  if (!isLiveHelpRequestWithSessionDetails(liveHelpRequest)) {
    return <AuthorAwaitingLiveHelpBanner post={post} postIsFullView={postIsFullView} />
  }

  if (!liveHelpRequest.session.userAttemptedJoining) {
    return <AuthorJoinLiveHelpBanner post={post} liveHelpRequest={liveHelpRequest} />
  }

  return (
    <AuthorReceivedLiveHelpBanner
      post={post}
      liveHelpRequest={liveHelpRequest}
      postIsFullView={postIsFullView}
    />
  )
}
